import { render, staticRenderFns } from "./TopTen.vue?vue&type=template&id=84b9beca&scoped=true&"
import script from "./TopTen.vue?vue&type=script&lang=js&"
export * from "./TopTen.vue?vue&type=script&lang=js&"
import style0 from "./TopTen.vue?vue&type=style&index=0&id=84b9beca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b9beca",
  null
  
)

export default component.exports